import { PipeTransform, Pipe } from "@angular/core";
import { DatePipe } from '@angular/common';
import { DailyRos } from "../Model/DailyRos.Model";

@Pipe({
  name: 'dailyRosFilter',
  standalone: false
})
export class DailyRosFilterPipe implements PipeTransform {
  constructor(private datePipe: DatePipe) { }

  transform(dailyRosList: DailyRos[], searchTerm: string, field?: string): DailyRos[] {
    if (!dailyRosList || !searchTerm?.trim()) {
      return dailyRosList;
    }

    const lowerSearch = searchTerm.toLowerCase();

    return dailyRosList.filter(item => {
      if (field && item[field]) {
        const value = this.formatValue(item[field], field);
        return value.includes(lowerSearch);
      }

      const searchableFields = [
        'LastUpdateDate',
        'applicationDate',
        'UserName',
        'bannerName'
      ];

      return searchableFields.some(key => {
        const value = this.formatValue(item[key], key);
        return value.includes(lowerSearch);
      });
    });
  }

  private formatValue(value: any, field: string): string {
    if (value == null) return '';
    if (field === 'LastUpdateDate' || field === 'applicationDate') {
      const formattedDate = this.datePipe.transform(value, 'MMMM dd, yyyy');
      return formattedDate ? formattedDate.toLowerCase() : '';
    }
    return value.toString().toLowerCase();
  }
}
